module.exports = __webpack_public_path__ + "static/solution15-64dd7decae4c05616987438fcba6702c.png";